import * as OnlineExamTemplateApi from "./onlineExamTemplate";
import * as AssignmentApi from "./assignment";
import * as AuthApi from "./auth";
import * as OnlineExamApi from "./onlineExam";
import * as SchoolInfoApi from "./schoolInfo";

const axios = require("axios").default;

const mainInstance = axios.create({
  baseURL: process.env.REACT_APP_ONLINE_EXAM_APP_URL,
  timeout: 30000,
  // headers: { 'X-Custom-Header': 'foobar' }
});

const konjInstance = axios.create({
  baseURL: process.env.REACT_APP_KONJ_APP_URL,
  timeout: 30000,
  // headers: { 'X-Custom-Header': 'foobar' }
});
const coreInstance = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_APP_URL,
  timeout: 30000,
  // headers: { 'X-Custom-Header': 'foobar' }
});

export {
  SchoolInfoApi,
  AuthApi,
  mainInstance,
  konjInstance,
  coreInstance,
  OnlineExamApi,
  AssignmentApi,
  OnlineExamTemplateApi,
};
